module.exports = __webpack_public_path__ + "static/media/WINGS-BNB.a536d753.svg";